import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import './Recaptcha.scss';

// const onChange = value => {
//   console.log('Captcha value:', value);
// };

const Recaptcha = ({ onChange }) => (
  <div className="recaptcha">
    <ReCAPTCHA
      sitekey="6LfIBiQaAAAAABNR0wZ44kGVuI7J5xny3ob2BP2A"
      // sitekey="6LfIBiQaAAAAAA1BMBD3glb-l19Etok6U58oTbHo"
      onChange={onChange}
    />
  </div>
);

export default Recaptcha;
